type LinksType = {
    [key: string]: string
}
export const ReusableLinks: LinksType = {
  AppStore : 'https://apps.apple.com/us/app/ingresse-eventos-e-ingressos/id815359760',
  GooglePlay : 'https://play.google.com/store/apps/details?id=com.ingresse.ticketbooth'
};
